import React, { useState, useEffect } from "react";

import { connect, useDispatch, useSelector } from "react-redux";

import NotificationDropdown from "../../components/Common/TopbarDropdown/NotificationDropdown";
import { Client, Account, Databases } from "appwrite";

//i18n
import { withTranslation } from "react-i18next";

//import images
import logoSm from "../../assets/images/logo-sm.png";
import logoLight from "../../assets/images/logo-light.png";
//actions
import {
  changeTopbarTheme,
  changeSidebarTheme,
  showRightSidebarAction,
  toggleLeftmenu,
  changeSidebarType,
  toggleTopbarBanner,
  isActivatedAgentStatus
} from "../../store/actions";

import {
  createLog,
  fetchAgentInfos,
  formatDate,
  getClientData,
  getUser,
  klaviyoUpdateProfile
} from "../../helpers/api_helper";

// Redux Store
import ProfileMenu from "../../components/Common/TopbarDropdown/ProfileMenu";
import AppsDropdown from "../../components/Common/TopbarDropdown/AppsDropdown";
import LiveGaugeChart from "../../components/Common/GaugeChart";
import { FormGroup, Input, UncontrolledTooltip } from "reactstrap";
import { Link, useNavigate } from "react-router-dom";
import logo_maaia from "../../assets/images/companies/img-3.png";
import Icons from "../../static/icons";
import LanguageDropdown from "../../components/Common/TopbarDropdown/LanguageDropdown";
import AlertTriangeMono from "../../assets/images/icons/AlertTriangeMono";
import { fetchUserSubscription } from "../../store/subscription/actions";
import { useMixpanel } from "../../Hooks/useMixpanel";
import MaaiaChangeStatus from "../../components/Common/MaaiaChangeStatus";

const Header = (props) => {
  const [search, setsearch] = useState(false);
  const [state, setState] = useState(true);
  const dispatch = useDispatch();
  const [userInfos, setUserInfos] = useState(undefined);
  const navigate = useNavigate();
  // const [numberAgentActive, setNumberAgentActive] = useState(undefined);
  // const [agentActive, setAgentActive] = useState(undefined);

  const { mixPanelTrack } = useMixpanel();
  const {
    agentStatus,
    client_data,
    subscription_trialing,
    next_billed_at,
    active_subscription_id,
    past_due
  } = useSelector((state) => ({
    agentStatus: state.GeneralStateRedux.agentStatus,
    client_data: state.GeneralStateRedux.client_data,
    subscription_trialing:
      state.subscription.subscription?.status === "trialing",
    next_billed_at: state.subscription.subscription?.current_period_end,
    active_subscription_id: state.subscription.subscription?.id,
    past_due: state.subscription.subscription?.status === "past_due"
  }));

  // async function getAgentInfos(company_id, agent_id) {
  //   try {
  //     const response = await fetchAgentInfos(company_id, agent_id);
  //     // console.log({ fetchAgentInfos: response });
  //     return response;
  //   } catch (error) {
  //     // console.log("Error while fecthing agent infos", error);
  //     return error;
  //   }
  // }
  // const checkAgentStatus = async (agents, company_id) => {
  //   console.log({ agents });

  //   let agentState = false;
  //   if (agents && agents.length) {
  //     for (const agent of agents) {
  //       try {
  //         // Faire la requête avec await
  //         //  const response = await getAgentInfos(company_id, agent.id);
  //         //   // console.log({ getAgentInfos: response });
  //         //   if (response && response.agent_data.State.Running) {
  //         //     agentState = true;
  //         //     break;
  //         //   }
  //         if (agent.active) {
  //           agentState = true;
  //           break;
  //         }
  //       } catch (erreur) {
  //         // console.error("Erreur lors de la requête:", erreur.message);
  //       }
  //     }
  //   } else {
  //     agentState = undefined;
  //   }
  //   setAgentActive(agents[0]);
  //   setNumberAgentActive(agentState);
  // };

  async function getUserAccount() {
    // setRequest(true);

    const client = new Client();
    const account = new Account(client);

    client
      .setEndpoint(process.env.REACT_APP_DATABASEURL)
      .setProject(process.env.REACT_APP_PROJECTID);

    const promise = account.get();
    return promise.then(
      async function (response) {
        // console.log("userAccount is", response);
        // setRequest(false);
        //     if(client_data.mail_config){
        //    }
        //fetchMailBoxes(data);
        const user = response;
        setUserInfos(user);
      },
      function (error) {
        console.log("Error getting user Account ", error);
        console.log(error); // Failure
        navigate("/login", {
          replace: false
        });
        // setRequest(false);
      }
    );
  }

  // function toggleFullscreen() {
  //   if (!document.fullscreenElement && /* alternative standard method */ !document.mozFullScreenElement && !document.webkitFullscreenElement) {
  //     // current working methods
  //     if (document.documentElement.requestFullscreen) {
  //       document.documentElement.requestFullscreen();
  //     } else if (document.documentElement.mozRequestFullScreen) {
  //       document.documentElement.mozRequestFullScreen();
  //     } else if (document.documentElement.webkitRequestFullscreen) {
  //       document.documentElement.webkitRequestFullscreen(Element.ALLOW_KEYBOARD_INPUT);
  //     }
  //   } else {
  //     if (document.cancelFullScreen) {
  //       document.cancelFullScreen();
  //     } else if (document.mozCancelFullScreen) {
  //       document.mozCancelFullScreen();
  //     } else if (document.webkitCancelFullScreen) {
  //       document.webkitCancelFullScreen();
  //     }
  //   }
  // }

  // function tToggle() {
  //   var body = document.body;
  //   if (window.screen.width <= 998) {
  //     body.classList.toggle("sidebar-enable");
  //   } else {
  //     body.classList.toggle("vertical-collpsed");
  //     body.classList.toggle("sidebar-enable");
  //   }
  // }

  // async function updateCompanyInfos(data) {
  //   const client = new Client();

  //   const databases = new Databases(client, "default");

  //   client.setEndpoint(process.env.REACT_APP_DATABASEURL).setProject(process.env.REACT_APP_PROJECTID);

  //   const promise = databases.updateDocument("default", "client_infos", localStorage.getItem("companyId"), JSON.stringify(data));

  //   return promise.then(
  //     async function (response) {
  //       console.log("updateCompanyInfos success", response); // Success
  //       return response;
  //     },
  //     function (error) {
  //       console.log("updateCompanyInfos error", error); // Failure
  //       return null;
  //     }
  //   );
  // }

  // const agentStatusChangeActions = async (old_val) => {
  //   const updatedAgentList = [
  //     {
  //       ...agentActive,
  //       active: !old_val
  //     }
  //   ];

  //   console.log({ updatedAgentList });

  //   const response = await updateCompanyInfos({
  //     agents: updatedAgentList.map((element) => JSON.stringify(element))
  //   });

  //   if (response) {
  //     setAgentActive({
  //       ...agentActive,
  //       active: !old_val
  //     });

  //     // Créer le log
  //     const company_id = localStorage.getItem("companyId");
  //     var user_id = JSON.parse(localStorage.getItem("authUser")).userId;

  //     const updates = {
  //       properties: {
  //         ai_active: old_val
  //       }
  //     };
  //     klaviyoUpdateProfile(company_id, updates);

  //     let logData = {
  //       eventCreatedAt: Date.now(),
  //       author_id: user_id,
  //       company_id: company_id,
  //       agent_id: agentActive.id
  //     };
  //     let logdata = {
  //       event: old_val ? "agent_disabled" : "agent_enabled",
  //       author_id: user_id,
  //       company_id: company_id,
  //       log_data: JSON.stringify(logData)
  //     };
  //     createLog(logdata, mixPanelTrack);

  //     dispatch(isActivatedAgentStatus(!old_val));
  //   }
  // };

  // const handleUserCompanyInfo = async () => {
  //   const userId = localStorage.getItem("companyId");
  //   // console.log({ userId });
  //   if (userId) {
  //     const response = await getClientData();
  //     if (response) {
  //       const list = response.agents;
  //       const agents = list.map((element) => JSON.parse(element));
  //       // checkAgentStatus(agents, userId);
  //     }
  //   }
  // };
  useEffect(() => {
    // handleUserCompanyInfo();
    getUserAccount();
    getUser();
  }, []);
  useEffect(() => {
    // handleUserCompanyInfo();
  }, [agentStatus]);

  useEffect(() => {
    props.toggleTopbarBanner(subscription_trialing || past_due || false);
  }, [past_due, subscription_trialing]);

  useEffect(() => {
    dispatch(fetchUserSubscription());
  }, [dispatch]);

  const [numberOfDays, setNumberOfDays] = useState(0);
  useEffect(() => {
    if (next_billed_at) {
      setNumberOfDays(
        Math.round(
          Math.abs(new Date(next_billed_at * 1000) - new Date()) /
            (24 * 60 * 60 * 1000)
        )
      );
    }
  }, [next_billed_at]);

  return (
    <React.Fragment>
      <header id="page-topbar">
        {props.isTopbarVisible && (
          <>
            {subscription_trialing &&
              next_billed_at &&
              active_subscription_id &&
              client_data && (
                <div
                  className="font-primary font-size-13 d-flex align-items-center"
                  id="banner"
                  style={{
                    backgroundColor: "#FFF2D7",
                    color: "black"
                  }}
                >
                  <AlertTriangeMono
                    width={"20px"}
                    height={"20px"}
                    className="me-2"
                  />
                  <span className="me-1" style={{ fontWeight: "bold" }}>
                    {props.t("Il vous reste")} {numberOfDays}{" "}
                    {numberOfDays > 1
                      ? `${props.t("jours")}`
                      : `${props.t("jour")}`}{" "}
                    {props.t("d'essai")}.
                  </span>
                  {props.t("Votre essai se termine le")}{" "}
                  {formatDate(props, next_billed_at, true, true)}.{" "}
                  {props.t(
                    "Écourtez votre essai et bénéficiez dès maintenant de tous les avantages du plan choisi."
                  )}
                  <span
                    onClick={() => {
                      navigate(
                        client_data.stripe_region === "US"
                          ? `/trial-interruption?region=US&id=${active_subscription_id}`
                          : `/trial-interruption?id=${active_subscription_id}`
                      );
                    }}
                    className="ms-1"
                    style={{
                      fontWeight: "bold",
                      color: "black",
                      textDecoration: "underline",
                      cursor: "pointer"
                    }}
                  >
                    {props.t("Écourter l'essai")}
                  </span>
                </div>
              )}
            {past_due && client_data && (
              <div
                className="font-primary font-size-13 d-flex align-items-center"
                id="banner"
                style={{
                  backgroundColor: "#FFF2D7",
                  color: "black"
                }}
                onClick={() => {
                  // props.toggleTopbarBanner(!props.isTopbarVisible);
                }}
              >
                <AlertTriangeMono
                  width={"20px"}
                  height={"20px"}
                  className="me-2"
                />
                <span className="me-1" style={{ fontWeight: "bold" }}>
                  {props.t("Votre dernier paiement a échoué.")}
                </span>
                {props.t(
                  "Pour continuer à utiliser votre abonnement à Synibox,"
                )}
                <span
                  onClick={() => {
                    navigate(
                      client_data.stripe_region === "US"
                        ? `/retry-payment-checkout?region=US`
                        : `/retry-payment-checkout`
                    );
                  }}
                  style={{
                    fontWeight: "bold",
                    color: "black",
                    textDecoration: "underline",
                    cursor: "pointer"
                  }}
                  className="ms-1"
                >
                  {props.t(
                    "réesayez ou mettez immédiatement à jour vos informations."
                  )}
                </span>
              </div>
            )}
          </>
        )}
        <div className="navbar-header">
          <div
            className="d-flex align-items-center"
            style={{ gap: "95px", marginLeft: "95px" }}
          >
            {/* <div className="vertical-menu-btn-container d-flex">
              <div className="navbar-brand-box text-center">
                <Link to="/" className="logo logo-dark font-primary">
                  <span className="logo-sm">
                    <img src={logoSm} alt="logo-sm-dark" height="22" />
                  </span>
                  <span className="logo-lg font-primary">
                    iAssistant
                  </span>
                </Link>

                <Link to="/" className="logo logo-light font-primary">
                  <span className="logo-sm font-primary">
                    <img src={logoSm} alt="logo-sm-light" height="22" />
                  </span>
                  <span className="logo-lg">
                    <img src={logoLight} alt="logo-light" height="24" />
                  </span>
                </Link>
              </div>
            </div> */}
            <Link to="/dashboard" className="d-flex app-title font-primary">
              <img
                style={{ userSelect: "none" }}
                src={logo_maaia}
                width={130}
                alt="logo"
              />
            </Link>
            <LiveGaugeChart userInfos={userInfos} />
          </div>

          <div
            className="d-flex align-items-center step-onboarding-2"
            style={{ gap: "20px" }}
          >
            <div className="dropdown d-inline-block d-lg-none ms-2">
              <button
                onClick={() => {
                  setsearch(!search);
                }}
                type="button"
                className="btn header-item noti-icon "
                id="page-header-search-dropdown"
              >
                <i className="ri-search-line" style={{ color: "black" }} />
              </button>
              <div
                className={
                  search
                    ? "dropdown-menu dropdown-menu-lg dropdown-menu-end p-0 show font-primary font-primary"
                    : "dropdown-menu dropdown-menu-lg dropdown-menu-end p-0 font-primary font-primary"
                }
                aria-labelledby="page-header-search-dropdown font-primary"
              >
                <form className="p-3">
                  <div className="form-group m-0">
                    <div className="input-group font-primary">
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Search ..."
                        aria-label="Recipient's username"
                      />
                      <div className="input-group-append">
                        <button className="btn btn-primary" type="submit">
                          <i className="ri-search-line" />
                        </button>
                      </div>
                    </div>
                  </div>
                </form>
              </div>
            </div>

            <MaaiaChangeStatus />
            {/* {numberAgentActive !== undefined ? (

              // <div className="d-flex align-items-center gap-2 step-onboarding-2">
              //   {numberAgentActive ? Icons.checkCircle : Icons.Xcircle} {props.t("serviceStatus")}{" "}
              //   {numberAgentActive ? props.t("Actif") : props.t("Inactif")}
              // </div>
              <div className="d-flex align-items-center gap-2 header__service_status__switch">
                {numberAgentActive ? props.t("Actif") : props.t("Inactif")}
                <FormGroup switch className="d-flex mb-0" style={{ position: "relative" }}>
                  <Input
                    id="service-status-switch"
                    disabled={client_data && (!client_data.shopify_token || !client_data.shopify_store_url)}
                    type="switch"
                    className="my-0"
                    onClick={() => {
                      agentStatusChangeActions(agentActive.active);
                    }}
                    checked={agentActive.active}
                    defaultChecked={agentActive.active}
                    style={{
                      width: "35px",
                      height: "22.5px",
                      backgroundColor: agentActive.active ? "#05B714" : "#FFA500",
                      borderColor: agentActive.active ? "#05B714" : "#FFA500",
                      boxShadow: "none",
                      cursor: client_data && (!client_data.shopify_token || !client_data.shopify_store_url) ? "not-allowed" : "pointer"
                    }}
                  />
                </FormGroup>
                <UncontrolledTooltip
                  isOpen={client_data && (!client_data.shopify_token || !client_data.shopify_store_url)}
                  innerClassName="font-primary"
                  placement="right"
                  target="service-status-switch">
                  {props.t("Votre CMS n'est pas connecté. Veuillez le connecter pour activer les fonctionnalités de Synibox.")}
                </UncontrolledTooltip>
              </div>
            ) : (
              ""
            )} */}
            {/* <FormGroup switch className="d-flex" style={{ position: 'relative' }}>
              <Input
                id="screen-mode-switch"
                type="switch"
                checked={state}
                onClick={() => {
                  console.log('switch val is ', !state);
                  dispatch(changeTopbarTheme(!state ? 'light' : 'dark'));
                  dispatch(changeSidebarTheme(!state ? 'light' : 'dark'));
                  setState(!state);
                }}
                style={{
                  width: '45px',
                  height: '22.5px',
                  backgroundColor: '#F10944',
                  borderColor: '#F10944',
                  boxShadow: 'none',
                }}
              />
            </FormGroup> */}

            {/* <div className="custom_switch">
              <label id="switch" class="switch mb-0">
                <input
                  type="checkbox"
                  checked={state}
                  onClick={() => {
                    console.log("switch val is ", !state);
                    dispatch(changeTopbarTheme(!state ? "light" : "dark"));
                    dispatch(changeSidebarTheme(!state ? "light" : "dark"));
                    setState(!state);
                  }}
                  id="slider"
                />
                <span class="slider round"></span>
              </label>
            </div> */}

            {/* <button
              type="button"
              style={{
                border: "none",
                padding: "8px 19px 8px 19px",
                borderRadius: "8px",
                background: "#FFA412",
                boxShadow:
                  "0px 16.20517px 37.81205px 0px rgba(255, 164, 18, 0.20)",
                color: "#FFFAF1",
                font: "500 15px/24px Poppins, sans-serif",
              }}
              className="d-flex align-items-center"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="30"
                height="14"
                viewBox="0 0 30 14"
                fill="none"
                style={{ marginRight: "10px" }}
              >
                <path
                  d="M29.9919 4.98139C29.726 5.6 29.3037 5.98255 28.6233 5.98255C28.4277 5.98255 28.4277 6.15348 28.4043 6.28372C28.0445 7.88721 27.6848 9.48255 27.325 11.086C27.1295 11.9488 26.9418 12.8035 26.7619 13.6663C26.7072 13.9267 26.629 14.0081 26.3553 13.9674C24.1342 13.6337 21.9053 13.3977 19.6686 13.2674C18.5815 13.2023 17.4867 13.186 16.3996 13.1372C14.984 13.0721 13.5685 13.1291 12.1608 13.1779C10.3855 13.2349 8.61804 13.3651 6.8584 13.5686C5.75568 13.6907 4.65297 13.8291 3.55026 13.9919C3.32346 14.0244 3.26872 13.9105 3.2218 13.7233C2.91679 12.4291 2.59614 11.143 2.29114 9.85697C2.0096 8.68488 1.73587 7.51279 1.52472 6.32441C1.48561 6.10465 1.41523 5.99069 1.16497 5.95814C0.398542 5.87674 -0.117621 5.10348 0.0231509 4.30581C0.148281 3.54883 0.867781 3.04418 1.61074 3.19883C2.3537 3.34535 2.83858 4.1186 2.64307 4.9C2.5805 5.16046 2.63525 5.26627 2.8464 5.38837C4.74682 6.46279 6.63942 7.54534 8.51637 8.63604C8.75881 8.77442 8.89176 8.75 9.07164 8.53023C10.6749 6.6093 12.2937 4.69651 13.9126 2.78372C14.069 2.59651 14.1238 2.48255 13.9361 2.26279C13.4825 1.71744 13.5607 0.854647 14.0847 0.366275C14.6008 -0.122097 15.3907 -0.122097 15.9225 0.374415C16.4309 0.854647 16.5169 1.70116 16.0711 2.24651C15.8834 2.47441 15.9303 2.59651 16.0946 2.79186C17.7213 4.70465 19.3401 6.63372 20.959 8.56279C21.1154 8.75814 21.2406 8.77442 21.4517 8.65232C23.3756 7.53721 25.3073 6.43023 27.239 5.32325C27.3641 5.25 27.4502 5.19302 27.3876 5.02209C27.1139 4.22441 27.5909 3.45116 28.2322 3.23139C28.9283 2.98721 29.593 3.32907 29.9449 4.10232C29.9606 4.12674 29.9684 4.1593 29.984 4.18372C29.9919 4.45232 29.9919 4.72093 29.9919 4.98139ZM14.9919 6.6093C14.9137 6.63372 14.8902 6.69883 14.8511 6.75581C14.4131 7.46395 13.9752 8.17209 13.5294 8.87209C13.4434 9.00232 13.4277 9.11628 13.5138 9.26279C13.9674 9.97907 14.421 10.7035 14.8667 11.4279C14.9684 11.5907 15.0388 11.5907 15.1326 11.4279C15.5784 10.7035 16.032 9.97907 16.4856 9.25465C16.5638 9.13255 16.5716 9.0186 16.4934 8.88837C16.0398 8.16395 15.5941 7.43953 15.1405 6.72325C15.1092 6.67441 15.0779 6.6093 14.9919 6.6093ZM26.1128 10.2965C26.1128 10.2639 26.105 10.2314 26.105 10.207C25.9408 9.57209 25.7765 8.93721 25.6123 8.29418C25.5654 8.09883 25.495 8.12325 25.3855 8.24535C24.9554 8.71744 24.5252 9.18953 24.0951 9.65348C23.9934 9.7593 23.9778 9.87325 24.0169 10.0116C24.1811 10.6302 24.3454 11.2407 24.494 11.8593C24.5487 12.0872 24.6191 12.0628 24.752 11.9244C25.1665 11.4686 25.5888 11.0128 26.0033 10.557C26.0581 10.4837 26.1285 10.4105 26.1128 10.2965ZM6.02941 9.92209C6.05287 9.80814 5.9903 9.72674 5.91992 9.65348C5.4976 9.18953 5.06747 8.73372 4.65297 8.26162C4.5122 8.10697 4.44964 8.11511 4.39489 8.32674C4.2463 8.93721 4.08207 9.53953 3.92565 10.15C3.89437 10.2558 3.86309 10.3779 3.94912 10.4674C4.41053 10.9802 4.87195 11.4849 5.34119 11.9895C5.41158 12.0709 5.47414 12.0628 5.50542 11.9488C5.67748 11.2733 5.84953 10.5977 6.02941 9.92209Z"
                  fill="#FFFAF1"
                />
              </svg>
              <span className="font-primary">{props.t("Evolution")}</span>
            </button > */}

            <LanguageDropdown />
            {/* <AppsDropdown />

            {/* <div className="dropdown d-none d-lg-inline-block ms-1">
              <button
                type="button"
                onClick={() => {
                  toggleFullscreen();
                }}
                className="btn header-item noti-icon"
                data-toggle="fullscreen"
              >
                <i className="ri-fullscreen-line" style={{ color: "black" }} />
              </button>
            </div> */}

            {/* <div
              className="dropdown d-inline-block"
              onClick={() => {
                props.showRightSidebarAction(!props.showRightSidebar);
              }}
            >
              <button
                type="button"
                className="header-item noti-icon right-bar-toggle waves-effect"
                style={{
                  padding: "10px",
                  borderRadius: "6.756px",
                  background: "#E8F7F7",
                }}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="21"
                  height="21"
                  viewBox="0 0 21 21"
                  fill="none"
                >
                  <path
                    d="M11.7353 0C12.4133 0.20339 12.7053 0.688396 12.7575 1.36636C12.7887 1.72099 12.8409 2.07562 12.8826 2.43025C12.8983 2.57106 12.9452 2.66493 13.1017 2.71186C13.3676 2.79531 13.6284 2.89961 13.8735 3.0352C13.9934 3.103 14.0821 3.08214 14.1864 2.9987C14.5254 2.72229 14.8696 2.46154 15.219 2.19557C15.8135 1.74185 16.4654 1.77836 16.9974 2.30508C17.4093 2.71186 17.8161 3.12386 18.2281 3.53585C18.7392 4.05215 18.7861 4.69883 18.3481 5.28292C18.0769 5.64276 17.8057 5.99739 17.5189 6.34681C17.4302 6.45632 17.4302 6.54498 17.4928 6.65971C17.6232 6.89961 17.7275 7.15515 17.8057 7.41591C17.8526 7.56193 17.9361 7.62451 18.0821 7.64016C18.515 7.69231 18.9478 7.74967 19.3754 7.80183C20.0638 7.88005 20.528 8.40156 20.5332 9.09518C20.5332 9.70535 20.5332 10.3207 20.5332 10.9309C20.528 11.5776 20.0899 12.0939 19.4537 12.193C19.0156 12.2555 18.5775 12.3129 18.1395 12.3598C17.9621 12.3807 17.8526 12.4381 17.79 12.631C17.7118 12.8866 17.5971 13.1265 17.4824 13.3664C17.4302 13.4759 17.4354 13.5541 17.5136 13.648C17.79 13.9922 18.0612 14.3416 18.3272 14.6962C18.7914 15.3012 18.7496 15.9479 18.2125 16.4902C17.8109 16.897 17.4041 17.3038 16.9974 17.7053C16.4706 18.2269 15.8031 18.2634 15.219 17.8096C14.8696 17.5385 14.5202 17.2725 14.1708 16.9961C14.0769 16.9179 13.9987 16.9074 13.8891 16.9648C13.644 17.0952 13.3833 17.2099 13.1173 17.2881C12.9556 17.3351 12.9035 17.4342 12.8878 17.5802C12.8357 18.0078 12.7783 18.4302 12.7262 18.8579C12.6479 19.5463 12.1316 20.0156 11.438 20.0209C10.8174 20.0209 10.202 20.0261 9.58144 20.0209C8.9452 20.0156 8.41847 19.5567 8.33503 18.9257C8.27245 18.4876 8.2203 18.0495 8.17336 17.6115C8.1525 17.4342 8.08992 17.3351 7.90739 17.2777C7.66749 17.2047 7.43281 17.1004 7.20856 16.9857C7.06254 16.9126 6.96345 16.9283 6.8435 17.0274C6.51495 17.2934 6.18118 17.5541 5.8422 17.8096C5.22681 18.279 4.58535 18.2321 4.03777 17.6845C3.6362 17.2829 3.23464 16.8866 2.83829 16.485C2.31156 15.9583 2.27505 15.296 2.72877 14.7066C2.98953 14.3729 3.23985 14.0339 3.51104 13.7053C3.61534 13.5802 3.6362 13.4759 3.55798 13.3246C3.44324 13.1056 3.33894 12.8761 3.27114 12.6415C3.21378 12.4433 3.09383 12.3807 2.90608 12.3651C2.52538 12.3233 2.14468 12.2555 1.76397 12.2243C1.12773 12.1669 0.726163 11.8279 0.533203 11.2229C0.533203 10.4146 0.533203 9.61147 0.533203 8.80313C0.720948 8.19818 1.12773 7.86441 1.76397 7.80704C2.14468 7.77053 2.52538 7.70274 2.90608 7.66623C3.09383 7.64537 3.20856 7.58801 3.27114 7.38983C3.34416 7.14993 3.45367 6.91525 3.56841 6.691C3.64142 6.5502 3.62056 6.46154 3.52668 6.34159C3.25028 6.00261 2.98431 5.65841 2.72356 5.309C2.28027 4.7249 2.32199 4.0678 2.8435 3.54628C3.24507 3.1395 3.65185 2.73794 4.05863 2.33116C4.59578 1.794 5.24246 1.75228 5.84741 2.21643C6.19161 2.4824 6.54103 2.74837 6.87479 3.01956C6.9791 3.10821 7.06775 3.11343 7.1877 3.05606C7.43281 2.94133 7.68314 2.8266 7.94389 2.74316C8.10035 2.691 8.16293 2.60235 8.17858 2.45111C8.21508 2.09648 8.27245 1.74185 8.30374 1.38722C8.35589 0.714472 8.64794 0.22425 9.3259 0.0260756C10.1238 0 10.9322 0 11.7353 0ZM10.5306 19.1239C10.8226 19.1239 11.1147 19.1291 11.4067 19.1239C11.6884 19.1186 11.8083 19.0196 11.8448 18.7379C11.923 18.1799 12.0013 17.6167 12.0638 17.0587C12.0951 16.7875 12.2255 16.6362 12.4811 16.5632C12.9348 16.4276 13.3781 16.2503 13.79 16.0156C14.0091 15.8905 14.202 15.9061 14.4054 16.0626C14.8435 16.412 15.2868 16.751 15.7301 17.09C15.9804 17.2829 16.1734 17.2725 16.3976 17.043C16.7835 16.6571 17.1694 16.2712 17.5554 15.8853C17.79 15.6506 17.8057 15.4628 17.6023 15.2021C17.2581 14.7536 16.9139 14.3051 16.5645 13.8618C16.4289 13.6897 16.4133 13.5124 16.5176 13.3194C16.7627 12.8709 16.9504 12.4016 17.1017 11.9166C17.1694 11.6923 17.3207 11.5776 17.5554 11.5515C18.129 11.4837 18.7027 11.4055 19.2764 11.3272C19.5475 11.2907 19.6518 11.1604 19.6518 10.8944C19.6571 10.2999 19.6571 9.71056 19.6518 9.11604C19.6518 8.84485 19.5475 8.7249 19.2764 8.68318C18.7027 8.60495 18.129 8.52673 17.5554 8.45893C17.3103 8.42764 17.1694 8.30769 17.0964 8.07301C16.9504 7.59844 16.7679 7.1395 16.528 6.70665C16.4133 6.50326 16.4289 6.31552 16.5801 6.12777C16.9296 5.68449 17.279 5.23598 17.6232 4.78748C17.8109 4.54237 17.8005 4.34941 17.5814 4.13038C17.2007 3.74967 16.82 3.36375 16.4341 2.98305C16.1681 2.71708 16.0013 2.70143 15.704 2.9309C15.2711 3.26467 14.8383 3.59844 14.4106 3.93742C14.2333 4.07301 14.056 4.11995 13.8526 4.01043C13.3989 3.76532 12.9243 3.56714 12.4341 3.42112C12.2203 3.35332 12.1056 3.21252 12.0743 2.98305C12.0013 2.40417 11.9282 1.82529 11.8448 1.24641C11.8031 0.975228 11.6831 0.876141 11.412 0.870926C10.8174 0.865711 10.2281 0.865711 9.63359 0.870926C9.36762 0.870926 9.24246 0.980443 9.20595 1.25163C9.12773 1.80965 9.04429 2.37288 8.98692 2.9309C8.95563 3.22295 8.80439 3.37419 8.53842 3.4472C8.08992 3.57236 7.66749 3.75489 7.26071 3.97914C7.03125 4.1043 6.83829 4.09387 6.62968 3.9322C6.19161 3.58279 5.74833 3.24381 5.30504 2.90482C5.05993 2.71708 4.86697 2.73272 4.64794 2.95176C4.2568 3.34289 3.86567 3.73403 3.47453 4.12516C3.25028 4.35463 3.23464 4.54237 3.43281 4.79791C3.7718 5.23598 4.11078 5.67406 4.45498 6.10691C4.60622 6.29465 4.64794 6.48761 4.52799 6.70143C4.28288 7.1395 4.10035 7.60365 3.95432 8.08344C3.88653 8.30769 3.74572 8.42764 3.50582 8.45893C2.93216 8.52673 2.3585 8.60495 1.78483 8.68318C1.498 8.7249 1.39891 8.83963 1.39891 9.12125C1.3937 9.70535 1.3937 10.2947 1.39891 10.8787C1.39891 11.1656 1.50322 11.2855 1.77962 11.322C2.33764 11.4003 2.90087 11.4837 3.45889 11.5411C3.7405 11.5724 3.89174 11.7132 3.96475 11.9739C4.09513 12.4224 4.27245 12.8605 4.50191 13.2673C4.63229 13.4967 4.61143 13.6897 4.44976 13.8983C4.10035 14.3364 3.76136 14.7797 3.42238 15.2229C3.23985 15.4576 3.2555 15.6558 3.45889 15.8644C3.85002 16.2555 4.24116 16.6467 4.63229 17.0378C4.8774 17.2829 5.05472 17.2934 5.33112 17.0795C5.76397 16.7458 6.19683 16.412 6.62447 16.073C6.79657 15.9374 6.9791 15.8801 7.18249 15.9896C7.64142 16.2399 8.12121 16.4329 8.62186 16.5893C8.83568 16.6571 8.9452 16.8083 8.97127 17.0326C9.03907 17.6115 9.1173 18.1904 9.20074 18.7692C9.23724 19.0248 9.36762 19.1291 9.62316 19.1343C9.93086 19.1291 10.2281 19.1239 10.5306 19.1239Z"
                    fill="#329993"
                  />
                  <path
                    d="M14.7129 10.0026C14.7129 12.3025 12.825 14.1852 10.5199 14.1852C8.22006 14.1852 6.3374 12.2973 6.3374 9.99219C6.3374 7.69232 8.22528 5.80966 10.5304 5.80966C12.8354 5.80966 14.7129 7.69754 14.7129 10.0026ZM7.21876 9.98698C7.21876 11.8123 8.69464 13.2986 10.5095 13.2986C12.3452 13.3038 13.8315 11.8227 13.8315 9.99741C13.8315 8.17211 12.3557 6.6858 10.5408 6.6858C8.70507 6.6858 7.21876 8.15647 7.21876 9.98698Z"
                    fill="#329993"
                  />
                </svg>
              </button>
            </div> */}

            <NotificationDropdown />

            <ProfileMenu user_infos={userInfos} />
          </div>
        </div>
      </header>
    </React.Fragment>
  );
};

const mapStatetoProps = (state) => {
  const {
    layoutType,
    showRightSidebar,
    leftMenu,
    leftSideBarType,
    isTopbarVisible
  } = state.Layout;
  return {
    layoutType,
    showRightSidebar,
    leftMenu,
    leftSideBarType,
    isTopbarVisible
  };
};

export default connect(mapStatetoProps, {
  toggleTopbarBanner,
  showRightSidebarAction,
  toggleLeftmenu,
  changeSidebarType
})(withTranslation()(Header));
